<master-compnent-app [obj]="obj"></master-compnent-app>